export default "__VITE_ASSET__CMgyeaNw__"